import { render, staticRenderFns } from "./AffiliateWeeklyPayout.vue?vue&type=template&id=2540107a&"
import script from "./AffiliateWeeklyPayout.vue?vue&type=script&lang=js&"
export * from "./AffiliateWeeklyPayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports